import React, { useEffect, useState } from 'react'
import { WarningFilled } from '@ant-design/icons'
import { colours } from '@qflow/theme'

// Expect allValues to be an array of objects with 2 keys, name and label
// the object name is the storedValue
// the object label is the displayed text
// [{ name: 'Meter', label: 'm' }, { name: 'Millimeter', label: 'mm' }]

export const UnitSelector: React.FC<{
  name: string
  currentValue: string
  allValues: { name: string; label: string }[]
  onChange?: any
  disabled?: boolean
}> = ({ name, currentValue, allValues, onChange, disabled = false }) => {
  const [initialLoad, setInitialLoad] = useState(true)
  const value = currentValue || allValues[0].name
  const index = allValues.findIndex(el => el.name === value)

  const maxIndex = allValues.length - 1

  // On initial load trigger the onchange event to ensure the validation
  // of the parent input element has been run with the correct unit.
  useEffect(() => {
    if (initialLoad && allValues[index]) {
      setInitialLoad(false)
      return onChange({
        target: {
          name: name,
          value: allValues[index].name
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = () => {
    const newIndex = index < maxIndex ? index + 1 : 0

    return onChange({
      target: {
        name: name,
        value: allValues[newIndex].name
      }
    })
  }

  if (disabled) {
    return <span>{allValues[index].label}</span>
  }

  return (
    <div id={name} className="unit-toggle" onClick={handleClick}>
      {index > -1 ? (
        allValues[index].label
      ) : (
        <WarningFilled
          style={{ fontSize: '16px', color: colours.RED }}
          title="Click to select unit"
        />
      )}
    </div>
  )
}
